var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69231 4.07693H4.07692C3.26087 4.07693 2.47824 4.40111 1.90121 4.97814C1.32417 5.55518 1 6.33781 1 7.15386V13.3077H3.30769",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4615 13.3077H21V2.53846C21 2.13044 20.8379 1.73912 20.5493 1.4506C20.2608 1.16209 19.8695 1 19.4615 1H10.2307C9.8227 1 9.43138 1.16209 9.14287 1.4506C8.85435 1.73912 8.69226 2.13044 8.69226 2.53846V11.2769",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46155 13.3077H13.3077",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3846 16.3846C8.08394 16.3846 9.46152 15.007 9.46152 13.3077C9.46152 11.6084 8.08394 10.2308 6.3846 10.2308C4.68526 10.2308 3.30768 11.6084 3.30768 13.3077C3.30768 15.007 4.68526 16.3846 6.3846 16.3846Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3845 16.3846C18.0838 16.3846 19.4614 15.007 19.4614 13.3077C19.4614 11.6084 18.0838 10.2308 16.3845 10.2308C14.6851 10.2308 13.3076 11.6084 13.3076 13.3077C13.3076 15.007 14.6851 16.3846 16.3845 16.3846Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.655c3c3be767f9229197153f0b8ea717.svg";
export { ForwardRef as ReactComponent };